export default __webpack_public_path__ + "static/media/me.d7be39a4.jpg";